import { all, call, debounce, fork, put } from "typed-redux-saga";
import { Action, globalSearchActions } from "./global-search-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { QuickSearchService } from "src/backend/openapi/v1";

export function* globalSearch(action: ReturnType<typeof globalSearchActions.globalSearchRequest>) {
  try {
    const response = yield* call(QuickSearchService.postApiV1QuickSearches, action.payload.data);
    yield put(globalSearchActions.globalSearchSuccess(response));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(globalSearchActions.globalSearchFail());
  }
}

export function* watch() {
  yield debounce(500, Action.GlobalSearchRequest, globalSearch);
}

export function* globalSearchSaga() {
  yield all([fork(watch)]);
}
